import React from 'react';
import { withInject } from '@piwikpro/platform';
import {
  AutoSavedTagsInputControl,
  Card,
  withTranslation,
} from '@piwikpro/ui-components';
import { FormValidator } from '@piwikpro/form-crate';
import { TrackerSettings, TrackerSettingsAttributes, TrackerSettingsResponse } from '../../../TrackerSettings';

export interface CampaignKeywordParamsProps {
  settings: TrackerSettingsResponse
  trackerSettings: TrackerSettings
  validation: FormValidator
  t: (key: string) => string
}

export class CampaignKeywordParams extends React.Component<CampaignKeywordParamsProps> {
  constructor(props: CampaignKeywordParamsProps) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values: Partial<TrackerSettingsAttributes>, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }: any) {
    const { trackerSettings, settings } = this.props;

    try {
      await trackerSettings.updateSettings(values);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        Object.keys(values)[0],
        (settings.attributes as any)[Object.keys(values)[0]],
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const { settings, t, validation } = this.props;

    return (
      <Card.Section>
        <AutoSavedTagsInputControl
          id="tracker-settings-campaign-keyword-params"
          label={t('apps.details.settings.campaignKeywordParams.title')}
          info={t('components:tagsInput.placeholder.default')}
          name="campaign_keyword_params"
          initialValue={settings.attributes.campaign_keyword_params}
          validationSchema={validation.createValidationSchema(
            (validators: any) => ({
              campaign_keyword_params: validators.trackerSettings.campaignKeywordParams,
            }),
          )}
          onSubmit={this.handleSubmit}
        />
      </Card.Section>
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
  validation: 'FormCrate.validation',
})(withTranslation(['administration'])(CampaignKeywordParams as any));
